import type { TFunction } from 'i18next';

import yup from '../../../helpers/yupInstance';

export interface ExerciseValidationOptions {
  skipTranslationsCheck?: boolean;
}

export function getExerciseValidation(
  t: TFunction,
  options?: ExerciseValidationOptions,
) {
  const skipTranslationsCheck = options?.skipTranslationsCheck ?? false;

  return yup.object({
    exerciseTranslations: yup
      .array()
      .of(
        yup.object().shape({
          title: yup
            .string()
            .max(256, t('formikValidation.maxLength').replace('{0}', '256')),
          description: yup
            .string()
            .nullable()
            .max(4096, t('formikValidation.maxLength').replace('{0}', '4096')),
        }),
      )
      .test(
        'at-least-one-translation',
        t('formikValidation.atLeastOneTranslationRequired'),
        function (value) {
          if (skipTranslationsCheck) return true;
          if (!value || value.length === 0) return false;
          return value.some((translation) => translation.title?.trim());
        },
      ),

    category: yup.object().required(t('formikValidation.categoryRequired')),
    mainMuscleGroup: yup
      .object()
      .required(t('formikValidation.mainMuscleGroupRequired')),
    equipment: yup.object().required(t('formikValidation.equipmentRequired')),
    language: yup.object().required(t('formikValidation.languageRequired')),
    options: yup
      .array()
      .max(4, t('formikValidation.exerciseOptionsMax').replace('{0}', '4')),
  });
}
